import { UploadScenarios } from 'interfaces/file-uploader';

export interface IDimensionConfig {
  width: number;
  height: number;
  description?: string;
  aspectRatio?: string;
}

export const uploadDimensions = new Map<UploadScenarios, IDimensionConfig>([
  [UploadScenarios.entLogo, {
    width: 200, height: 200, description: 'Square logo for enterprise branding', aspectRatio: '1:1',
  }],
  [UploadScenarios.entSponsor, {
    width: 250, height: 250, description: 'Partnership/Sponsor logo (flexible aspect ratios)', aspectRatio: '1:1',
  }],
  [UploadScenarios.entPromotional, {
    width: 704, height: 466, description: 'Landing page image option 1 (3:2 ratio)', aspectRatio: '3:2',
  }],
  [UploadScenarios.entPromotional_2, {
    width: 1920, height: 1080, description: 'Landing page image option 2 (16:9 ratio)', aspectRatio: '16:9',
  }],
  [UploadScenarios.adminProfile, {
    width: 150, height: 150, description: 'Admin profile picture', aspectRatio: '1:1',
  }],
  [UploadScenarios.expertProfile, {
    width: 150, height: 150, description: 'Expert profile media', aspectRatio: '1:1',
  }],
  [UploadScenarios.expertSponsor, {
    width: 250, height: 250, description: 'Expert sponsor banner', aspectRatio: '1:1',
  }],
  [UploadScenarios.expertBadge, {
    width: 225, height: 225, description: 'Badge image (1:1 ratio, <500KB)', aspectRatio: '1:1',
  }],
  [UploadScenarios.articleBanner, {
    width: 736, height: 414, description: 'Article image (uses doubled size as article card). Note: Article cards use 368×212px', aspectRatio: '16:9',
  }],
  [UploadScenarios.sessionBanner, {
    width: 1200, height: 800, description: 'Session thumbnail banner', aspectRatio: '3:2',
  }],
  [UploadScenarios.groupBanner, {
    width: 736, height: 400, description: 'Group Banner', aspectRatio: '16:9',
  }],
  [UploadScenarios.formBadge, {
    width: 225, height: 225, description: 'Form badge (1:1 ratio, <500KB)', aspectRatio: '1:1',
  }],
  [UploadScenarios.ctaBackground, {
    width: 1200, height: 400, description: 'Call-to-action background', aspectRatio: '3:1',
  }],
  [UploadScenarios.textBlock, { width: 800, height: 400, description: 'Text block illustration' }],
  [UploadScenarios.sessionHighlightMedia, {
    width: 368, height: 212, description: 'Session card', aspectRatio: '16:9',
  }],
]);
